export default "__VITE_ASSET__BNurhnkt__"